import { useRef } from "react"
import { useGet } from "utils/useFetch"
import type { IWorkplaceByIdRes } from "../typings"
import { SETUP_WORKPLACE_QUERY_KEY } from "../typings"
import { getResumeStepFromWorkplaceConfig } from "../utils/workplaceSetupResumeStep"

type Params = {
  selectedWorkplaceId: string
  currentStep: number
  workplaceIdFromUrl: string
  onResumeStep: (step: number) => void
}

export function useWorkplaceSetupProgress({
  selectedWorkplaceId,
  currentStep,
  workplaceIdFromUrl,
  onResumeStep,
}: Params) {
  const hasResumedFromUrlRef = useRef(false)

  const shouldFetchProgress =
    !!selectedWorkplaceId &&
    (currentStep >= 1 || selectedWorkplaceId === workplaceIdFromUrl)

  const { data: setupProgressRes, isFetching: isLoadingSetupProgress } =
    useGet<IWorkplaceByIdRes>({
      url: `/v1/time-attendance/workplaces/${selectedWorkplaceId}`,
      queryKey: [SETUP_WORKPLACE_QUERY_KEY, selectedWorkplaceId],
      instanceKey: "ewaAxiosInstance",
      enabled: shouldFetchProgress,
      refetchOnMount: false,
      onSuccess: (data: IWorkplaceByIdRes) => {
        const config = data?.data?.workplaceConfig as
          | Record<string, unknown>
          | null
          | undefined
        if (!config) return

        if (
          workplaceIdFromUrl &&
          selectedWorkplaceId === workplaceIdFromUrl &&
          !hasResumedFromUrlRef.current
        ) {
          hasResumedFromUrlRef.current = true
          onResumeStep(getResumeStepFromWorkplaceConfig(config))
        }
      },
    })

  return { setupProgressRes, isLoadingSetupProgress }
}

